"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("./colors");
var fonts_1 = require("./fonts");
var theme = {
    colorsPalette: colors_1.colorsPalette,
    fontSizes: fonts_1.fontSizes,
    fontWeights: fonts_1.fontWeights,
};
exports.default = theme;
//# sourceMappingURL=index.js.map